import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const MainLayout = ({ children, className }) => {
    return (
        <>
            <Navbar />
            <main className={`w-full bg-background min-h-screen mt-16 ${className || ""}`}>
                {children}
            </main>
            <Footer />
        </>
    )
}

export default MainLayout
